import type { PageType, UnpublishState } from "../type";

import { canSetDefaultPageTypes } from "../utils/helper";
import { getterTypes } from "./types";

const initState: {
  publishedPage: PageType[];
  isFetched: boolean;
  unpublishList: number[];
  isLoading: boolean;
  isOpenPopup: boolean;
  isUsingWebSocket?: boolean;
  waitingCampaignList: number[];
} = {
  publishedPage: [],
  isFetched: false,
  unpublishList: [],
  isLoading: false,
  isOpenPopup: false,
  isUsingWebSocket: undefined,
  waitingCampaignList: [],
}

export const getters = {
  [getterTypes.GET_IS_FETCHED](state: UnpublishState) {
    return state.isFetched;
  },
  [getterTypes.GET_PUBLISHED_PAGE](state: UnpublishState) {
    return state.publishedPage;
  },
  [getterTypes.GET_UNPUBLISH_LIST](state: UnpublishState) {
    return state.unpublishList;
  },
  [getterTypes.GET_IS_LOADING](state: UnpublishState) {
    return state.isLoading;
  },
  [getterTypes.GET_IS_OPEN_POPUP](state: UnpublishState) {
    return state.isOpenPopup;
  },
  [getterTypes.GET_IS_USING_WEB_SOCKET](state: UnpublishState) {
    return state.isUsingWebSocket;
  },
  [getterTypes.GET_WAITING_CAMPAIGN_LIST](state: UnpublishState){
    return state.waitingCampaignList;
  },
  [getterTypes.SELECTABLE_PAGE](state: UnpublishState) {
    return state.publishedPage.filter(page => (!(page.isDefault && canSetDefaultPageTypes(page.type)) && !page.isInCampaign));
  }
}

export default initState;
